import React, {useContext, useState} from "react";

import {buyNowContext} from "../BuyNow";
import QuantitySelector from "./QuantitySelector";
import Subtotal from "../product_selection/Subtotal";
import {PRODUCT_CATEGORIES} from "../../../../constants";

export const AdminAccessQuantity = () => {
  const {
    lineItems,
    removeLineItems,
    quantitiesEnabled,
    adminAccessProducts,
    setLineItemsByCategory,
  } = useContext(buyNowContext);

  const adminAccessProduct = adminAccessProducts.find(p => p.category === PRODUCT_CATEGORIES.ADMIN_ACCESS);
  const adminAccessLineItem = lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.ADMIN_ACCESS);
  const [adminAccessQuantity, setAdminAccessQuantity] = useState(adminAccessLineItem ? adminAccessLineItem.quantity : 0);

  return (
    <div className="row mb-2" style={{marginTop: "50px"}}>
      <div className="col-6 fw-bold">
        {quantitiesEnabled &&
          <>
            <h4 className="text-dark header-txt">Quantity</h4>
            <QuantitySelector
              quantityValue={adminAccessQuantity}
              minVal={0}
              onChange={val => {
                setAdminAccessQuantity(val);

                if (val)
                  setLineItemsByCategory([{product: adminAccessProduct, quantity: val}]);
                else
                  removeLineItems(adminAccessLineItem);
              }}
            />
          </>
        }
      </div>

      <Subtotal lineItem={adminAccessLineItem} className="col-6 fw-bold" style={{textAlign: "right"}}
                defaultPrice={adminAccessProduct.price}/>
    </div>
  );
};
